// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20z1_","productName":"Table_productName__3_D94"};